import moment from 'moment'
import React, { useMemo } from 'react'

import { parseTime } from './helpers'
import TimePicker, { TTimePicker } from './index'

const TimePickerDate = (props: TTimePicker): React.ReactElement => {
  const { ...rest } = props

  const onChange = (t: string): void => {
    const { hour, minute } = parseTime(t)
    const originalTime = moment(props.value)
    const newTime = moment(originalTime.isValid() ? originalTime : moment())
    newTime.hours(Number(hour))
    newTime.minutes(Number(minute))
    if (props.onChange) {
      props.onChange(newTime.toISOString())
    }
  }

  const value = useMemo(() => {
    const originalTime = moment(props.value)
    const newTime = moment(originalTime.isValid() ? originalTime : moment())
    return moment(newTime).format('HH:mm')
  }, [props.value])

  return <TimePicker {...rest} onChange={onChange} value={value} />
}

export default TimePickerDate
